import actionTypes from '../actionTypes';

const summaryCardData = {
	tyValue: '0',
	yoy: '0% YoY',
	errorCode: 0,
	loading: false,
};

const onHandData = {
	data: [],
	summary: { total: 0, yoy: 0 },
	loading: false,
	errorCode: 0,
};

const initialState = {
	basicInfoData: {
		catName: '',
		subCatName: '',
		itemName: '',
		itemId: '',
		upc: '',
		brandName: '',
		supplier: '',
		supplierId: '',
	},
	basicInfoLoading: false,
	basicInfoErrorCode: 0,

	itemUnitOnHandInventory: {
		...onHandData,
	},
	itemRetailOnHandInventory: {
		...onHandData,
	},

	itemOnHandInventory: {
		...onHandData,
	},
	itemOnHandInventoryUnit: {
		...onHandData,
	},

	itemInventoryOnOrder: {
		...onHandData,
	},
	itemInventoryOnOrderUnit: {
		...onHandData,
	},

	itemInventoryDCToStore: {
		...onHandData,
	},
	itemInventoryDCToStoreUnit: {
		...onHandData,
	},

	itemInventoryInWhse: {
		...onHandData,
	},
	itemInventoryInWhseUnit: {
		...onHandData,
	},

	itemTrendData: {},
	itemTrendErrorCode: 0,
	itemTrendLoading: false,

	itemInStockData: {},
	itemInStockDataLoading: false,
	itemInStockDataErrorCode: 0,

	netSalesSummaryCard: { ...summaryCardData },
	inStockSummaryCard: { ...summaryCardData },
	storeCountSummaryCard: { ...summaryCardData },
	nilPickRateSummaryCard: { ...summaryCardData },

	// This is consumed by Summary > Sales channel breakdown,
	// & Sales > channel breakdown
	channelBreakDownData: [],
	channelBreakDownloading: false,
	channelBreakDownErrorCode: 0,

	netSalesData: { data: null, summary: {} },
	netSalesLoading: true,
	netSalesErrorCode: 0,

	unitsData: { data: null, summary: {} },
	unitsLoading: false,
	unitsErrorCode: 0,

	relativeNetSalesData: [],
	relativeNetSalesLoading: true,
	relativeNetSalesErrorCode: 0,

	relativeUnitsData: [],
	relativeUnitsLoading: true,
	relativeUnitsErrorCode: 0,

	unitsChannelBreakDownData: {},
	unitsChannelBreakDownLoading: false,
	unitsChannelBreakDownErrorCode: 0,

	nilPickRateData: {},
	nilPickRateLoading: true,
	nilPickRateErrorCode: 0,

	firstTimePickRateData: {},
	firstTimePickRateLoading: false,
	firstTimePickRateErrorCode: 0,

	preSubtituteRateData: {},
	preSubtituteRateLoading: false,
	preSubtituteRateErrorCode: 0,

	postSubtituteRateData: {},
	postSubtituteRateLoading: false,
	postSubtituteRateErrorCode: 0,

	netSalesMapSummary: {
		stateGeoJSONData: {
			type: 'FeatureCollection',
			features: [],
		},
		summary: {},
	},
	netSalesMapSummaryLoading: false,
	netSalesMapSummaryErrorCode: 0,

	sortBy: 'DESC',
	salesSortBy: 'asc',

	weekOfSupplyStore: null,
	weekOfSupplyStoreLoading: false,
	weekOfSupplyStoreError: 0,

	weekOfSupplyDC: null,
	weekOfSupplyDCLoading: false,
	weekOfSupplyDCError: 0,

	itemLocationGridStateData: {},
	isLoadingItemLocationGridStateData: false,
	isItemLocationGridStateError: 0,

	itemLocationGridStoreData: {},
	isLoadingItemLocationGridStoreData: false,
	isItemLocationGridStoreError: 0,

	map: {
		apiKey: null,
		keyPath: null,
	},
};

const itemDrillDownReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		case actionTypes.GET_MAP_KEY_SUCCESS:
			return {
				...state,
				map: { ...action.payload },
			};
		case actionTypes.GET_MAP_KEY_FAILURE:
			return {
				...state,
				map: { ...state?.map, error: action.payload },
			};
		case actionTypes.GET_ITEM_BASIC_INFO:
			return {
				...state,
				basicInfoLoading: true,
			};
		case actionTypes.GET_ITEM_BASIC_INFO_SUCCESS:
			return {
				...state,
				basicInfoLoading: false,
				basicInfoData: { ...action.payload },
				basicInfoErrorCode: 0,
			};
		case actionTypes.GET_ITEM_BASIC_INFO_FAILURE:
			return {
				...state,
				basicInfoLoading: false,
				basicInfoErrorCode: action.payload,
			};

		case actionTypes.GET_ITEM_UNIT_ON_HAND_INVENTORY:
			return {
				...state,
				itemUnitOnHandInventory: {
					...initialState.itemUnitOnHandInventory,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_UNIT_ON_HAND_INVENTORY_SUCCESS:
			return {
				...state,
				itemUnitOnHandInventory: {
					...initialState.itemUnitOnHandInventory,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_UNIT_ON_HAND_INVENTORY_FAILURE:
			return {
				...state,
				itemUnitOnHandInventory: {
					...initialState.itemUnitOnHandInventory,
					loading: false,
					errorCode: action.payload,
				},
			};
		case actionTypes.GET_ITEM_RETAIL_ON_HAND_INVENTORY:
			return {
				...state,
				itemRetailOnHandInventory: {
					...initialState.itemRetailOnHandInventory,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_RETAIL_ON_HAND_INVENTORY_SUCCESS:
			return {
				...state,
				itemRetailOnHandInventory: {
					...initialState.itemRetailOnHandInventory,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_RETAIL_ON_HAND_INVENTORY_FAILURE:
			return {
				...state,
				itemRetailOnHandInventory: {
					...initialState.itemRetailOnHandInventory,
					loading: false,
					errorCode: action.payload,
				},
			};

		case actionTypes.GET_ITEM_NET_SALES_SUMMARY_CARD:
			return {
				...state,
				netSalesSummaryCard: {
					...initialState.netSalesSummaryCard,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_NET_SALES_SUMMARY_CARD_SUCCESS:
			return {
				...state,
				netSalesSummaryCard: {
					...initialState.netSalesSummaryCard,
					...action.payload,
					loading: false,
				},
			};
		case actionTypes.GET_ITEM_NET_SALES_SUMMARY_CARD_FAILURE:
			return {
				...state,
				netSalesSummaryCard: {
					...initialState.netSalesSummaryCard,
					errorCode: action.payload,
					loading: false,
				},
			};
		case actionTypes.GET_ITEM_IN_STOCK_SUMMARY_CARD:
			return {
				...state,
				inStockSummaryCard: {
					...initialState.inStockSummaryCard,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_IN_STOCK_SUMMARY_CARD_SUCCESS:
			return {
				...state,
				inStockSummaryCard: {
					...initialState.inStockSummaryCard,
					...action.payload,
					loading: false,
				},
			};
		case actionTypes.GET_ITEM_IN_STOCK_SUMMARY_CARD_FAILURE:
			return {
				...state,
				inStockSummaryCard: {
					...initialState.inStockSummaryCard,
					errorCode: action.payload,
					loading: false,
				},
			};
		case actionTypes.GET_ITEM_STORE_COUNT_SUMMARY_CARD:
			return {
				...state,
				storeCountSummaryCard: {
					...initialState.storeCountSummaryCard,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_STORE_COUNT_SUMMARY_CARD_SUCCESS:
			return {
				...state,
				storeCountSummaryCard: {
					...initialState.storeCountSummaryCard,
					...action.payload,
					loading: false,
				},
			};
		case actionTypes.GET_ITEM_STORE_COUNT_SUMMARY_CARD_FAILURE:
			return {
				...state,
				storeCountSummaryCard: {
					...initialState.storeCountSummaryCard,
					errorCode: action.payload,
					loading: false,
				},
			};
		case actionTypes.GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD:
			return {
				...state,
				nilPickRateSummaryCard: {
					...initialState.nilPickRateSummaryCard,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD_SUCCESS:
			return {
				...state,
				nilPickRateSummaryCard: {
					...initialState.nilPickRateSummaryCard,
					...action.payload,
					loading: false,
				},
			};
		case actionTypes.GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD_FAILURE:
			return {
				...state,
				nilPickRateSummaryCard: {
					...initialState.nilPickRateSummaryCard,
					errorCode: action.payload,
					loading: false,
				},
			};

		// For Net Summary & Sales channel breakdown
		case actionTypes.GET_ITEM_CHANNEL_BREAKDOWN:
			return {
				...state,
				channelBreakDownloading: true,
			};
		case actionTypes.GET_ITEM_CHANNEL_BREAKDOWN_SUCCESS:
			return {
				...state,
				channelBreakDownloading: false,
				channelBreakDownData: action.payload.data,
				channelBreakDownErrorCode: 0,
			};
		case actionTypes.GET_ITEM_CHANNEL_BREAKDOWN_FAILURE:
			return {
				...state,
				channelBreakDownData: {},
				channelBreakDownloading: false,
				channelBreakDownErrorCode: action.payload,
			};

		case actionTypes.GET_ITEM_NET_SALES:
			return {
				...state,
				netSalesLoading: true,
			};
		case actionTypes.GET_ITEM_NET_SALES_SUCCESS:
			return {
				...state,
				netSalesLoading: false,
				netSalesData: { ...action.payload },
				netSalesErrorCode: 0,
			};
		case actionTypes.GET_ITEM_NET_SALES_FAILURE:
			return {
				...state,
				netSalesLoading: false,
				netSalesData: { ...initialState.netSalesData },
				netSalesErrorCode: action.payload,
			};

		case actionTypes.GET_ITEM_UNITS:
			return {
				...state,
				unitsLoading: true,
			};
		case actionTypes.GET_ITEM_UNITS_SUCCESS:
			return {
				...state,
				unitsLoading: false,
				unitsData: { ...action.payload },
				unitsErrorCode: 0,
			};
		case actionTypes.GET_ITEM_UNITS_FAILURE:
			return {
				...state,
				unitsLoading: false,
				unitsData: { ...initialState.unitsData },
				unitsErrorCode: action.payload,
			};

		case actionTypes.GET_ITEM_RELATIVE_NET_SALES:
			return {
				...state,
				relativeNetSalesLoading: true,
			};
		case actionTypes.GET_ITEM_RELATIVE_NET_SALES_SUCCESS:
			return {
				...state,
				relativeNetSalesLoading: false,
				relativeNetSalesData: action.payload,
				relativeNetSalesErrorCode: 0,
			};
		case actionTypes.GET_ITEM_RELATIVE_NET_SALES_FAILURE:
			return {
				...state,
				relativeNetSalesLoading: false,
				relativeNetSalesData: [],
				relativeNetSalesErrorCode: action.payload,
			};

		case actionTypes.GET_ITEM_RELATIVE_UNITS:
			return {
				...state,
				relativeUnitsLoading: true,
			};
		case actionTypes.GET_ITEM_RELATIVE_UNITS_SUCCESS:
			return {
				...state,
				relativeUnitsLoading: false,
				relativeUnitsData: action.payload,
				relativeUnitsErrorCode: 0,
			};
		case actionTypes.GET_ITEM_RELATIVE_UNITS_FAILURE:
			return {
				...state,
				relativeUnitsLoading: false,
				relativeUnitsData: [],
				relativeUnitsErrorCode: action.payload,
			};

		case actionTypes.GET_UNITS_CHANNEL_BREAKDOWN:
			return {
				...state,
				unitsChannelBreakDownLoading: true,
			};
		case actionTypes.GET_UNITS_CHANNEL_BREAKDOWN_SUCCESS:
			return {
				...state,
				unitsChannelBreakDownLoading: false,
				unitsChannelBreakDownData: action.payload.data,
				unitsChannelBreakDownErrorCode: 0,
			};
		case actionTypes.GET_UNITS_CHANNEL_BREAKDOWN_FAILURE:
			return {
				...state,
				unitsChannelBreakDownData: [],
				unitsChannelBreakDownLoading: false,
				unitsChannelBreakDownErrorCode: action.payload,
			};

		case actionTypes.GET_ITEM_ONHAND:
			return {
				...state,
				itemOnHandInventory: {
					...initialState.itemOnHandInventory,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_ONHAND_SUCCESS:
			return {
				...state,
				itemOnHandInventory: {
					...initialState.itemOnHandInventory,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_ONHAND_FAILURE:
			return {
				...state,
				itemOnHandInventory: {
					...initialState.itemOnHandInventory,
					loading: false,
					errorCode: action.payload,
				},
			};

		case actionTypes.GET_ITEM_ONHAND_UNITS:
			return {
				...state,
				itemOnHandInventoryUnit: {
					...initialState.itemOnHandInventoryUnit,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_ONHAND_UNITS_SUCCESS:
			return {
				...state,
				itemOnHandInventoryUnit: {
					...initialState.itemOnHandInventoryUnit,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_ONHAND_UNITS_FAILURE:
			return {
				...state,
				itemOnHandInventoryUnit: {
					...initialState.itemOnHandInventoryUnit,
					loading: false,
					errorCode: action.payload,
				},
			};

		case actionTypes.GET_ITEM_ONORDER:
			return {
				...state,
				itemInventoryOnOrder: {
					...initialState.itemInventoryOnOrder,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_ONORDER_SUCCESS:
			return {
				...state,
				itemInventoryOnOrder: {
					...initialState.itemInventoryOnOrder,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_ONORDER_FAILURE:
			return {
				...state,
				itemInventoryOnOrder: {
					...initialState.itemInventoryOnOrder,
					loading: false,
					errorCode: action.payload,
				},
			};

		case actionTypes.GET_ITEM_ONORDER_UNITS:
			return {
				...state,
				itemInventoryOnOrderUnit: {
					...initialState.itemInventoryOnOrderUnit,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_ONORDER_UNITS_SUCCESS:
			return {
				...state,
				itemInventoryOnOrderUnit: {
					...initialState.itemInventoryOnOrderUnit,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_ONORDER_UNITS_FAILURE:
			return {
				...state,
				itemInventoryOnOrderUnit: {
					...initialState.itemInventoryOnOrderUnit,
					loading: false,
					errorCode: action.payload,
				},
			};

		case actionTypes.GET_ITEM_DCTOSTORE:
			return {
				...state,
				itemInventoryDCToStore: {
					...initialState.itemInventoryDCToStore,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_DCTOSTORE_SUCCESS:
			return {
				...state,
				itemInventoryDCToStore: {
					...initialState.itemInventoryDCToStore,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_DCTOSTORE_FAILURE:
			return {
				...state,
				itemInventoryDCToStore: {
					...initialState.itemInventoryDCToStore,
					loading: false,
					errorCode: action.payload,
				},
			};

		case actionTypes.GET_ITEM_DCTOSTORE_UNITS:
			return {
				...state,
				itemInventoryDCToStoreUnit: {
					...initialState.itemInventoryDCToStoreUnit,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_DCTOSTORE_UNITS_SUCCESS:
			return {
				...state,
				itemInventoryDCToStoreUnit: {
					...initialState.itemInventoryDCToStoreUnit,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_DCTOSTORE_UNITS_FAILURE:
			return {
				...state,
				itemInventoryDCToStoreUnit: {
					...initialState.itemInventoryDCToStoreUnit,
					loading: false,
					errorCode: action.payload,
				},
			};

		case actionTypes.GET_ITEM_INWHSE:
			return {
				...state,
				itemInventoryInWhse: {
					...initialState.itemInventoryInWhse,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_INWHSE_SUCCESS:
			return {
				...state,
				itemInventoryInWhse: {
					...initialState.itemInventoryInWhse,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_INWHSE_FAILURE:
			return {
				...state,
				itemInventoryInWhse: {
					...initialState.itemInventoryInWhse,
					loading: false,
					errorCode: action.payload,
				},
			};

		case actionTypes.GET_ITEM_INWHSE_UNITS:
			return {
				...state,
				itemInventoryInWhseUnit: {
					...initialState.itemInventoryInWhseUnit,
					loading: true,
				},
			};
		case actionTypes.GET_ITEM_INWHSE_UNITS_SUCCESS:
			return {
				...state,
				itemInventoryInWhseUnit: {
					...initialState.itemInventoryInWhseUnit,
					loading: false,
					data: [...action.payload.data],
					summary: { ...action.payload.summary },
				},
			};
		case actionTypes.GET_ITEM_INWHSE_UNITS_FAILURE:
			return {
				...state,
				itemInventoryInWhseUnit: {
					...initialState.itemInventoryInWhseUnit,
					loading: false,
					errorCode: action.payload,
				},
			};

		case actionTypes.GET_ITEM_INV_TREND:
			return {
				...state,
				itemTrendLoading: true,
			};
		case actionTypes.GET_ITEM_INV_TREND_SUCCESS:
			return {
				...state,
				itemTrendData: action.payload,
				itemTrendLoading: false,
				itemTrendErrorCode: 0,
			};
		case actionTypes.GET_ITEM_INV_TREND_FAILURE:
			return {
				...state,
				itemTrendData: {},
				itemTrendLoading: false,
				itemTrendErrorCode: action.payload,
			};

		case actionTypes.GET_ITEM_INSTOCK:
			return {
				...state,
				itemInStockDataLoading: true,
			};
		case actionTypes.GET_ITEM_INSTOCK_SUCCESS:
			return {
				...state,
				itemInStockData: action.payload.itemInStock,
				itemInStockDataLoading: false,
				itemInStockDataErrorCode: 0,
			};
		case actionTypes.GET_ITEM_INSTOCK_FAILURE:
			return {
				...state,
				itemInStockData: {},
				itemInStockDataLoading: false,
				itemInStockDataErrorCode: action.payload,
			};
		case actionTypes.GET_NIL_PICK_RATE:
			return {
				...state,
				nilPickRateLoading: true,
			};
		case actionTypes.GET_NIL_PICK_RATE_SUCCESS:
			return {
				...state,
				nilPickRateLoading: false,
				nilPickRateData: action.payload,
				nilPickRateErrorCode: 0,
			};
		case actionTypes.GET_NIL_PICK_RATE_FAILURE:
			return {
				...state,
				nilPickRateData: {},
				nilPickRateLoading: false,
				nilPickRateErrorCode: action.payload,
			};

		case actionTypes.GET_FIRTS_TIME_PICK_RATE:
			return {
				...state,
				firstTimePickRateLoading: true,
			};
		case actionTypes.GET_FIRTS_TIME_PICK_RATE_SUCCESS:
			return {
				...state,
				firstTimePickRateLoading: false,
				firstTimePickRateData: action.payload,
				firstTimePickRateErrorCode: 0,
			};
		case actionTypes.GET_FIRTS_TIME_PICK_RATE_FAILURE:
			return {
				...state,
				firstTimePickRateData: {},
				firstTimePickRateLoading: false,
				firstTimePickRateErrorCode: action.payload,
			};

		case actionTypes.GET_PRE_SUBSTITUTE_RATE:
			return {
				...state,
				preSubtituteRateLoading: true,
			};
		case actionTypes.GET_PRE_SUBSTITUTE_RATE_SUCCESS:
			return {
				...state,
				preSubtituteRateLoading: false,
				preSubtituteRateData: action.payload,
				preSubtituteRateErrorCode: 0,
			};
		case actionTypes.GET_PRE_SUBSTITUTE_RATE_FAILURE:
			return {
				...state,
				preSubtituteRateData: {},
				preSubtituteRateLoading: false,
				preSubtituteRateErrorCode: action.payload,
			};

		case actionTypes.GET_POST_SUBSTITUTE_RATE:
			return {
				...state,
				postSubtituteRateLoading: true,
			};
		case actionTypes.GET_POST_SUBSTITUTE_RATE_SUCCESS:
			return {
				...state,
				postSubtituteRateLoading: false,
				postSubtituteRateData: action.payload,
				postSubtituteRateErrorCode: 0,
			};
		case actionTypes.GET_POST_SUBSTITUTE_RATE_FAILURE:
			return {
				...state,
				postSubtituteRateData: {},
				postSubtituteRateLoading: false,
				postSubtituteRateErrorCode: action.payload,
			};

		case actionTypes.GET_ITEM_NET_SALES_MAP_SUMMARY:
			return {
				...state,
				netSalesMapSummaryLoading: true,
			};
		case actionTypes.GET_ITEM_NET_SALES_MAP_SUMMARY_SUCCESS:
			return {
				...state,
				netSalesMapSummary: action.payload,
				netSalesMapSummaryLoading: false,
				netSalesMapSummaryErrorCode: 0,
			};
		case actionTypes.GET_ITEM_NET_SALES_MAP_SUMMARY_FAILURE:
			return {
				...state,
				netSalesMapSummary: { ...initialState.netSalesMapSummary },
				netSalesMapSummaryLoading: false,
				netSalesMapSummaryErrorCode: action.payload,
			};

		case actionTypes.GET_TOP_BOTTOM_ITEM_GRID:
			return {
				...state,
				sortBy: action.payload,
			};

		case actionTypes.GET_TOP_BOTTOM_SALES_ITEM_GRID:
			return {
				...state,
				salesSortBy: action.payload,
			};

		case actionTypes.GET_WEEK_OF_SUPPLY_STORE_DATA: {
			return {
				...state,
				weekOfSupplyStoreLoading: true,
			};
		}

		case actionTypes.GET_WEEK_OF_SUPPLY_STORE_SUCCESS: {
			return {
				...state,
				weekOfSupplyStoreLoading: false,
				weekOfSupplyStore: action.payload.weekOfSupplyStore,
			};
		}

		case actionTypes.GET_WEEK_OF_SUPPLY_STORE_FAILURE: {
			return {
				...state,
				weekOfSupplyStoreLoading: false,
				weekOfSupplyStore: null,
				weekOfSupplyStoreError: action.payload,
			};
		}

		case actionTypes.GET_WEEK_OF_SUPPLY_DC_DATA: {
			return {
				...state,
				weekOfSupplyDCLoading: true,
			};
		}

		case actionTypes.GET_WEEK_OF_SUPPLY_DC_SUCCESS: {
			return {
				...state,
				weekOfSupplyDCLoading: false,
				weekOfSupplyDC: action.payload.weekOfSupplyDC,
			};
		}

		case actionTypes.GET_WEEK_OF_SUPPLY_DC_FAILURE: {
			return {
				...state,
				weekOfSupplyDCLoading: false,
				weekOfSupplyDC: null,
				weekOfSupplyDCError: action.payload,
			};
		}
		case actionTypes.GET_ITEM_LOCATION_GRID_STATE_DATA:
			return {
				...state,
				isLoadingItemLocationGridStateData: true,
			};
		case actionTypes.GET_ITEM_LOCATION_GRID_STATE_SUCCESS:
			return {
				...state,
				isLoadingItemLocationGridStateData: false,
				itemLocationGridStateData: action.payload,
				isItemLocationGridStateError: 0,
			};
		case actionTypes.GET_ITEM_LOCATION_GRID_STATE_FAILURE:
			return {
				...state,
				isLoadingItemLocationGridStateData: false,
				isItemLocationGridStateError: action.payload,
			};
		case actionTypes.GET_ITEM_LOCATION_GRID_STORE_DATA:
			return {
				...state,
				isLoadingItemLocationGridStoreData: true,
			};
		case actionTypes.GET_ITEM_LOCATION_GRID_STORE_SUCCESS:
			return {
				...state,
				isLoadingItemLocationGridStoreData: false,
				itemLocationGridStoreData: action.payload,
				isItemLocationGridStoreError: 0,
			};
		case actionTypes.GET_ITEM_LOCATION_GRID_STORE_FAILURE:
			return {
				...state,
				isLoadingItemLocationGridStoreData: false,
				isItemLocationGridStoreError: action.payload,
			};

		default:
			return state;
	}
};

export default itemDrillDownReducer;
